import { ApiCore } from './utilities/core'


export const dashboardAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        url: `api/${tenantSlug}/dashboard-reports`
    })
};

export const exportCSVAPI = (tenantSlug: string) => {
    return new ApiCore({
        getAll: true,
        url: `api/${tenantSlug}/export/tickets`
    })
};